import React, { useRef, useEffect, useState } from 'react';
import 'mapbox-gl/dist/mapbox-gl.css';
import mapboxgl from 'mapbox-gl';
import '../../styles/MapBox.css';
import './mapbox-styles.css'; // New styles
import towerImg from '../../../img/torre2_azul2.png';
import serverImg from '../../../img/server_up_3.png';
import { servidores_id } from '../../generales/GroupsId';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';

function calcularPuntoMedio(coordenadas1, coordenadas2) {
  const [x1, y1] = coordenadas1;
  const [x2, y2] = coordenadas2;
  return [(x1 + x2) / 2, (y1 + y2) / 2];
}

const COLORS = {
  up: '#057a55',   // verde   — Conectado
  upGlow: 'rgba(5,122,85,0.15)',
  upRing: 'rgba(5,122,85,0.20)',

  dwn: '#db2777',   // rosa    — Desconectado
  dwnGlow: 'rgba(219,39,119,0.15)',
  dwnRing: 'rgba(219,39,119,0.20)',

  odd: '#e02424',   // rojo    — ODD
  oddGlow: 'rgba(224,36,36,0.15)',
  oddRing: 'rgba(224,36,36,0.20)',

  exc: '#d97706',   // ámbar   — Excepción
  excGlow: 'rgba(217,119,6,0.15)',
  excRing: 'rgba(217,119,6,0.20)',

  unk: '#94a3b8',   // gris    — Desconocido
  unkGlow: 'rgba(148,163,184,0.15)',
  unkRing: 'rgba(148,163,184,0.20)',

  hub: '#1a56db',   // azul    — Hub/Central
  hubGlow: 'rgba(26,86,219,0.15)',
  hubRing: 'rgba(26,86,219,0.20)',

  linkActive: '#93c5fd',   // azul claro — enlace activo
  linkDown: '#fca5a5',   // rojo claro — enlace caído (dashed)
  linkExc: '#fde68a',   // ámbar claro — enlace con excepción
};

const MapboxMapNew = ({
  languaje,
  dataAgencies,
  markersUnknown,
  setExceptData,
  setPopups,
  setShowPopups,
  exceptions,
  capas,
  switchesFO,
  switchesMO,
  setCapas,
  actualizar_rfi,
  actualizar_lpr,
  mapAux,
  setmapAux,
  search_rfid,
  global_longitud,
  global_latitude,
  global_zoom,
  devices,
  markers,
  markersWOR,
  lines,
  downs,
  towers,
  rfid,
  lpr,
  ubicacion,
  switches,
  handleMarkerClick
}) => {
  let latitud_provicional = (ubicacion.groupid === 0 ? global_latitude.value : ubicacion.latitud);
  let longitud_provicional = (ubicacion.groupid === 0 ? global_longitud.value : ubicacion.longitud);
  const zoom_provicional = (ubicacion.groupid === 0 ? global_zoom.value : 11);
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);
  const animationFrameIds = useRef([]);
  const [rfidInterval, setRfidInterval] = useState(0);
  const [lprInterval, setLprInterval] = useState(0);

  const getColorById = (id) => {
    if (!dataAgencies || !dataAgencies.data || !dataAgencies.data.data) return '#ffffff';
    if (id === 0) return '#757474';
    const agency = dataAgencies.data.data.find(agency => agency.id === id);
    return agency ? agency.color : '#ffffff';
  };

  const getNameById = (id) => {
    if (!dataAgencies || !dataAgencies.data || !dataAgencies.data.data) return 'Unknown';
    if (id === 0) return 'MANTTO';
    const agency = dataAgencies.data.data.find(agency => agency.id === id);
    return agency ? agency.shortName : 'Unknown';
  };

  const idCapaExistente = (id) => {
    return Object.values(capas).some(capa => capa.id === id);
  };

  mapboxgl.accessToken = 'pk.eyJ1IjoiZ2lvcm9jaGEiLCJhIjoiY2xpZWJyZTR3MHpqcjNlcWRvaHR1em5sayJ9._SOrMWsc39Coa2dTHR072Q';

  useEffect(() => {
    mapRef.current = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/mapbox/light-v11',
      // style: 'mapbox://styles/giorocha/clveuj6so02at01ph3b3g02z6',
      zoom: zoom_provicional,
      center: [longitud_provicional, latitud_provicional]
    });

    const map = mapRef.current;
    setmapAux(map);

    map.on('load', () => {
      // Base map adjustments for light style
      try {
        if (map.getStyle()) {
          map.setPaintProperty('background', 'background-color', '#eef2f7');
          map.setPaintProperty('water', 'fill-color', '#c8d8e8');
          if (map.getLayer('road-primary')) map.setPaintProperty('road-primary', 'line-color', '#d8e4ee');
          if (map.getLayer('road-secondary')) map.setPaintProperty('road-secondary', 'line-color', '#dce8f0');
          if (map.getLayer('road-street')) map.setPaintProperty('road-street', 'line-color', '#e4ecf2');
        }
      } catch (e) {
        console.warn("Some map layers not found for styling", e);
      }

      /************************************************************ CAPA Servers ************************************************************************ */
      if (servidores_id[ubicacion.dispId] !== undefined) {
        map.loadImage(serverImg, (error, image) => {
          if (error) throw error;
          if (!map.hasImage('server')) map.addImage('server', image);

          const upImgSource = {
            type: 'geojson',
            data: {
              type: 'FeatureCollection',
              features: markersWOR,
            },
          };
          const upImgLayer = {
            id: 'host-server',
            type: 'symbol',
            source: 'host-server',
            layout: {
              'icon-image': 'server',
              'icon-size': 0.06,
              'icon-anchor': 'bottom',
            },
          };

          if (!map.getSource('host-server')) map.addSource('host-server', upImgSource);
          if (!map.getLayer('host-server')) map.addLayer(upImgLayer);

          if (!idCapaExistente('host-server')) {
            setCapas((prevCapas) => ({
              ...prevCapas,
              [Object.keys(prevCapas).length]: { show: true, name: 'Servers', id: `host-server`, layer: upImgLayer, source: upImgSource, nivel: 5 },
            }));
          }
        });
      }

      /************************************************************ CAPA host-markerWOR (UP/STATUS) ************************************************************************ */
      if (markersWOR.length !== 0) {
        // NODES GLOW
        const markerWORGlow = {
          id: 'host-markerWOR-glow',
          type: 'circle',
          source: {
            type: 'geojson',
            data: { type: 'FeatureCollection', features: markersWOR }
          },
          paint: {
            'circle-radius': [
              'match', ['get', 'level'],
              -1, 14, // UP
              0, 12,  // UNK
              1, 14,  // UP
              2, 14,  // EXC
              3, 16,  // ODD
              4, 16,  // ODD/ALERT
              12
            ],
            'circle-color': [
              'match', ['get', 'level'],
              -1, COLORS.upRing,
              0, COLORS.unkRing,
              1, COLORS.upRing,
              2, COLORS.excRing,
              3, COLORS.oddRing,
              4, COLORS.oddRing,
              COLORS.unkRing
            ],
            'circle-opacity': 0.6,
            'circle-blur': 0.8
          }
        };

        // NODES MAIN
        const markerWOR = {
          id: 'host-markerWOR',
          type: 'circle',
          source: {
            type: 'geojson',
            data: { type: 'FeatureCollection', features: markersWOR }
          },
          filter: ['!', ['has', 'point_count']],
          paint: {
            'circle-color': [
              'match', ['get', 'level'],
              -1, COLORS.upGlow,
              0, COLORS.unkGlow,
              1, COLORS.upGlow,
              2, COLORS.excGlow,
              3, COLORS.oddGlow,
              4, COLORS.oddGlow,
              COLORS.unkGlow
            ],
            'circle-radius': [
              'match', ['get', 'level'],
              -1, 7,
              0, 6,
              1, 7,
              2, 7,
              3, 8,
              4, 8,
              6
            ],
            'circle-stroke-width': 1.8,
            'circle-stroke-color': [
              'match', ['get', 'level'],
              -1, COLORS.up,
              0, COLORS.unk,
              1, COLORS.up,
              2, COLORS.exc,
              3, COLORS.odd,
              4, COLORS.odd,
              COLORS.unk
            ],
            'circle-stroke-opacity': 1
          }
        };

        // NODES CENTER
        const markerWORCenter = {
          id: 'host-markerWOR-center',
          type: 'circle',
          source: {
            type: 'geojson',
            data: { type: 'FeatureCollection', features: markersWOR }
          },
          paint: {
            'circle-radius': 3,
            'circle-color': [
              'match', ['get', 'level'],
              -1, COLORS.up,
              0, COLORS.unk,
              1, COLORS.up,
              2, COLORS.exc,
              3, COLORS.odd,
              4, COLORS.odd,
              COLORS.unk
            ]
          }
        };

        map.addLayer(markerWORGlow);
        map.addLayer(markerWOR);
        map.addLayer(markerWORCenter);

        if (!idCapaExistente('host-markerWOR')) {
          setCapas((prevCapas) => ({
            ...prevCapas,
            [Object.keys(prevCapas).length]: { show: true, name: capitalizeFirstLetter(lang[languaje]['conectados']), id: `host-markerWOR`, layer: markerWOR, source: null, nivel: 1 },
          }));
        }

        // Popup logic
        map.on('mouseleave', 'host-markerWOR', () => {
          document.querySelectorAll('.custom-popup').forEach(p => p.remove());
        });

        map.on('mouseenter', 'host-markerWOR', (e) => {
          if (e.features[0].properties.tooltip) {
            const coordinates = e.features[0].geometry.coordinates.slice();
            const props = e.features[0].properties;
            const metrics = JSON.parse(props.metrics) || [];

            // Map level to status for popup styling
            const levelMap = { '-1': 'up', '0': 'unk', '1': 'up', '2': 'exc', '3': 'odd', '4': 'odd' };
            const status = levelMap[props.level] || 'unk';
            const statusLabel = status.toUpperCase();

            const metricsHtml = (metrics.length === 0)
              ? `<div class="nw-popup-row"><span class="nw-popup-label">${capitalizeFirstLetter(lang[languaje]['sinMetricas'])}</span></div>`
              : metrics.map(m => `
                  <div class="nw-popup-row">
                    <span class="nw-popup-label">${m.name}</span>
                    <span class="nw-popup-value">${m.value} ${m.units}</span>
                  </div>
                `).join("");

            new mapboxgl.Popup({ className: 'custom-popup', closeButton: false })
              .setLngLat(coordinates)
              .setHTML(`
                <div class="nw-popup-header">
                  <span>${props.name_hostC}</span>
                  <span class="nw-popup-status ${status}">${statusLabel}</span>
                </div>
                <div class="nw-popup-body">
                  ${metricsHtml}
                </div>
              `)
              .addTo(map);
          }
        });

        map.on('click', 'host-markerWOR', (e) => {
          handleMarkerClick(e.features[0].properties);
        });
      }

      /************************************************************ CAPA host-markersUnknown ************************************************************************ */
      if (markersUnknown.length !== 0) {
        const markerUnknown = {
          id: 'host-markersUnknown',
          type: 'circle',
          source: {
            type: 'geojson',
            data: { type: 'FeatureCollection', features: markersUnknown },
          },
          filter: ['!', ['has', 'point_count']],
          paint: {
            'circle-color': COLORS.unkGlow,
            'circle-radius': 6,
            'circle-stroke-width': 1.8,
            'circle-stroke-color': COLORS.unk,
          },
        };
        map.addLayer(markerUnknown);

        if (!idCapaExistente('host-markersUnknown')) {
          setCapas((prevCapas) => ({
            ...prevCapas,
            [Object.keys(prevCapas).length]: { show: true, name: capitalizeFirstLetter(lang[languaje]['desconectados']), id: `host-markersUnknown`, layer: markerUnknown, source: null, nivel: 1 },
          }));
        }

        map.on('mouseleave', 'host-markersUnknown', () => {
          document.querySelectorAll('.custom-popup').forEach(p => p.remove());
        });

        map.on('mouseenter', 'host-markersUnknown', (e) => {
          if (e.features[0].properties.tooltip) {
            const coordinates = e.features[0].geometry.coordinates.slice();
            const props = e.features[0].properties;

            new mapboxgl.Popup({ className: 'custom-popup', closeButton: false })
              .setLngLat(coordinates)
              .setHTML(`
                <div class="nw-popup-header">
                  <span>${props.name_hostC}</span>
                  <span class="nw-popup-status unk">UNK</span>
                </div>
                <div class="nw-popup-body">
                  <div class="nw-popup-row"><span class="nw-popup-label">Status</span><span class="nw-popup-value">Desconocido</span></div>
                </div>
              `)
              .addTo(map);
          }
        });

        map.on('click', 'host-markersUnknown', (e) => {
          handleMarkerClick(e.features[0].properties);
        });
      }

      /************************************************************ CAPA LINEAS (Relaciones) ************************************************************************ */
      if (lines.length !== 0) {
        const LineConect = {
          id: 'line-conection',
          type: 'line',
          source: {
            type: 'geojson',
            data: { type: 'FeatureCollection', features: lines },
          },
          paint: {
            'line-color': [
              'match', ['get', 'severity'],
              0, COLORS.linkActive,
              1, COLORS.linkExc,
              2, COLORS.linkExc,
              3, COLORS.linkDown,
              4, COLORS.linkDown,
              COLORS.linkActive
            ],
            'line-width': 1,
            'line-opacity': 0.8
          },
        };
        map.addLayer(LineConect);
        if (!idCapaExistente('line-conection')) {
          setCapas((prevCapas) => ({
            ...prevCapas,
            [Object.keys(prevCapas).length]: { show: true, name: capitalizeFirstLetter(lang[languaje]['relaciones']), id: `line-conection`, layer: LineConect, source: null, nivel: 2 },
          }));
        }
      }

      /************************************************************ CAPA Fibra Optica (Animation) ************************************************************************ */
      const addThroughputLayer = (id, features, name, isMW = false) => {
        if (!features || features.length === 0) return;
        const sourceId = `source-${id}`;
        map.addSource(sourceId, { type: 'geojson', data: { type: 'FeatureCollection', features: features } });

        const layer = {
          id: id,
          type: 'line',
          source: sourceId,
          paint: {
            'line-color': ['match', ['get', 'connectivity'], -1, COLORS.up, 0, COLORS.dwn, 1, COLORS.up, COLORS.up],
            'line-width': isMW ? 5 : 8,
            'line-dasharray': [0, 0.3, 0.2]
          }
        };
        map.addLayer(layer);

        if (!idCapaExistente(id)) {
          setCapas((prevCapas) => ({
            ...prevCapas,
            [Object.keys(prevCapas).length]: { show: true, name: name, id: id, layer: layer, source: null, nivel: 2 },
          }));
        }

        // Animation logic
        const dashArraySequence = [[0, 0.3, 0.2], [0, 0.1, 0.2, 0.4], [0, 0.2, 0.2, 0.3], [0, 0.3, 0.2, 0.2], [0, 0.4, 0.2, 0.1], [0, 0.5, 0.2, 0]];
        let step = 0;
        function animate(timestamp) {
          if (!map || !map.getStyle()) return;
          const newStep = parseInt((timestamp / 50) % dashArraySequence.length);
          if (newStep !== step) {
            if (map.getLayer(id)) map.setPaintProperty(id, 'line-dasharray', dashArraySequence[step]);
            step = newStep;
          }
          const frameId = requestAnimationFrame(animate);
          animationFrameIds.current.push(frameId);
        }
        animate(0);

        map.on('mouseenter', id, (e) => {
          const coordinates = calcularPuntoMedio(e.features[0].geometry.coordinates[0], e.features[0].geometry.coordinates[1]);
          const data = JSON.parse(e.features[0].properties.Metric);

          new mapboxgl.Popup({ className: 'custom-popup', closeButton: false })
            .setLngLat(coordinates)
            .setHTML(`
              <div class="nw-popup-header">Enlace: ${data.host_padre} → ${data.host_hijo}</div>
              <div class="nw-popup-body">
                <div class="nw-popup-row"><span class="nw-popup-label">Medio</span><span class="nw-popup-value">${data.medio}</span></div>
                <div class="nw-popup-row"><span class="nw-popup-label">Status</span><span class="nw-popup-value">${data.itemname_status_enlace || 'OK'}</span></div>
                <div class="nw-popup-row"><span class="nw-popup-label">Send</span><span class="nw-popup-value">${data.itemname_throughput_send || '0'}</span></div>
                <div class="nw-popup-row"><span class="nw-popup-label">Recv</span><span class="nw-popup-value">${data.itemname_throughput_received || '0'}</span></div>
              </div>
            `)
            .addTo(map);
        });
        map.on('mouseleave', id, () => document.querySelectorAll('.custom-popup').forEach(p => p.remove()));
      };

      addThroughputLayer('line-throughtput', switches.length !== 0 ? switches[0] : [], capitalizeFirstLetter(lang[languaje]['fibraOptica']));
      addThroughputLayer('line-throughtput2', switches.length > 1 ? switches[1] : [], capitalizeFirstLetter(lang[languaje]['microondas']), true);

      /************************************************************ CAPA DOWNS (Pulsing Dot) ************************************************************************ */
      const size = 200;
      const pulsingDot = {
        width: size, height: size, data: new Uint8Array(size * size * 4),
        onAdd: function () {
          const canvas = document.createElement('canvas');
          canvas.width = this.width; canvas.height = this.height;
          this.context = canvas.getContext('2d');
        },
        render: function () {
          const t = (performance.now() % 1000) / 1000;
          const radius = (size / 2) * 0.3;
          const outerRadius = (size / 2) * 0.7 * t + radius;
          const context = this.context;
          context.clearRect(0, 0, this.width, this.height);
          context.beginPath();
          context.arc(this.width / 2, this.height / 2, outerRadius, 0, Math.PI * 2);
          context.fillStyle = `rgba(219, 39, 119, ${0.4 * (1 - t)})`; // Rosa glow
          context.fill();
          context.beginPath();
          context.arc(this.width / 2, this.height / 2, radius, 0, Math.PI * 2);
          context.fillStyle = COLORS.dwn;
          context.strokeStyle = 'white';
          context.lineWidth = 2 + 4 * (1 - t);
          context.fill();
          context.stroke();
          this.data = context.getImageData(0, 0, this.width, this.height).data;
          map.triggerRepaint();
          return true;
        }
      };

      if (!map.hasImage('pulsing-dot')) map.addImage('pulsing-dot', pulsingDot, { pixelRatio: 2 });

      const downLayer = {
        id: 'host-down',
        type: 'symbol',
        source: {
          type: 'geojson',
          data: { type: 'FeatureCollection', features: downs },
        },
        filter: ['!', ['has', 'point_count']],
        layout: {
          'icon-image': 'pulsing-dot',
          'icon-size': 0.5,
          'icon-allow-overlap': true,
        },
      };

      map.addLayer(downLayer);
      if (!idCapaExistente('host-down')) {
        setCapas((prevCapas) => ({
          ...prevCapas,
          [Object.keys(prevCapas).length]: { show: true, name: 'Downs', id: `host-down`, layer: downLayer, source: null, nivel: 5 },
        }));
      }

      map.on('mouseenter', 'host-down', (e) => {
        const coordinates = e.features[0].geometry.coordinates.slice();
        const props = e.features[0].properties;
        const metrics = props.metrics ? JSON.parse(props.metrics) : [];

        new mapboxgl.Popup({ className: 'custom-popup', closeButton: false })
          .setLngLat(coordinates)
          .setHTML(`
            <div class="nw-popup-header">
              <span>${props.name_hostC || props.Name}</span>
              <span class="nw-popup-status dwn">DOWN</span>
            </div>
            <div class="nw-popup-body">
              <div class="nw-popup-row"><span class="nw-popup-label">Status</span><span class="nw-popup-value">Desconectado</span></div>
              ${metrics.map(m => `<div class="nw-popup-row"><span class="nw-popup-label">${m.name}</span><span class="nw-popup-value">${m.value} ${m.units}</span></div>`).join("")}
            </div>
          `)
          .addTo(map);
      });
      map.on('mouseleave', 'host-down', () => document.querySelectorAll('.custom-popup').forEach(p => p.remove()));
      map.on('click', 'host-down', (e) => handleMarkerClick(e.features[0].properties));

      /************************************************************ CAPA EXCEPTIONS ************************************************************************ */
      if (exceptions.length !== 0) {
        const exceptLayer = {
          id: 'host-except',
          type: 'circle',
          source: {
            type: 'geojson',
            data: { type: 'FeatureCollection', features: exceptions },
          },
          paint: {
            'circle-color': [
              'match', ['get', 'type'],
              0, '#FF1E1E',
              1, '#F000BF',
              2, '#00ff70',
              COLORS.exc
            ],
            'circle-radius': 7,
            'circle-stroke-width': 1.8,
            'circle-stroke-color': '#fff',
          },
        };
        map.addLayer(exceptLayer);

        // Persistent Labels for Exceptions
        exceptions.forEach(feature => {
          const coordinates = feature.geometry.coordinates.slice();
          const agencyId = feature.properties.exception_agency_id;

          new mapboxgl.Popup({
            className: 'custom-popup-except',
            closeButton: false,
            closeOnClick: false
          })
            .setLngLat(coordinates)
            .setHTML(`
            <div class='cont-except' style='border: 1px solid #ffffff; pointer-events: none;'>
              <div class='valexcept' style='background: ${getColorById(agencyId)}; padding: 2px 6px; border-radius: 4px; color: white; font-size: 10px; font-weight: bold;'>
                ${getNameById(agencyId).toUpperCase()}
              </div>
            </div>
          `)
            .addTo(map);
        });

        if (!idCapaExistente('host-except')) {
          setCapas((prevCapas) => ({
            ...prevCapas,
            [Object.keys(prevCapas).length]: { show: true, name: capitalizeFirstLetter(lang[languaje]['exepciones']), id: `host-except`, layer: exceptLayer, source: null, nivel: 3 },
          }));
        }

        map.on('mouseenter', 'host-except', (e) => {
          const coordinates = e.features[0].geometry.coordinates.slice();
          const props = e.features[0].properties;
          new mapboxgl.Popup({ className: 'custom-popup', closeButton: false })
            .setLngLat(coordinates)
            .setHTML(`
              <div class="nw-popup-header">
                <span>${props.Name}</span>
                <span class="nw-popup-status exc">EXC</span>
              </div>
              <div class="nw-popup-body">
                <div class="nw-popup-row"><span class="nw-popup-label">Tipo</span><span class="nw-popup-value">Excepción</span></div>
              </div>
            `)
            .addTo(map);
        });
        map.on('mouseleave', 'host-except', () => document.querySelectorAll('.custom-popup').forEach(p => p.remove()));
        map.on('click', 'host-except', (e) => handleMarkerClick(e.features[0].properties));
      }

      /************************************************************ CAPA TORRES ************************************************************************ */
      map.loadImage(towerImg, (error, image) => {
        if (error) throw error;
        if (!map.hasImage('tower')) map.addImage('tower', image);

        const towerSource = { type: 'geojson', data: { type: 'FeatureCollection', features: towers } };
        const towerLayer = {
          id: 'tower-marker', type: 'symbol', source: 'tower-marker',
          layout: { 'icon-image': 'tower', 'icon-size': 0.12, 'icon-anchor': 'bottom' }
        };

        if (servidores_id[ubicacion.dispId] === undefined) {
          if (!map.getSource('tower-marker')) map.addSource('tower-marker', towerSource);
          if (!map.getLayer('tower-marker')) map.addLayer(towerLayer);
        }

        if (!idCapaExistente('tower-marker')) {
          setCapas((prevCapas) => ({
            ...prevCapas,
            [Object.keys(prevCapas).length]: { show: true, name: capitalizeFirstLetter(lang[languaje]['torres']), id: `tower-marker`, layer: towerLayer, source: towerSource, nivel: 5 },
          }));
        }
      });

    });

    return () => {
      animationFrameIds.current.forEach(id => cancelAnimationFrame(id));
      if (mapRef.current) mapRef.current.remove();
    };
  }, [downs, markersWOR, markersUnknown, lines, exceptions, towers, switches]);

  return <div id="map" style={{ position: 'absolute', top: 0, bottom: 0, width: '100%' }} />;
};

export default MapboxMapNew;
